<template>
  <div class="app-container">
    <fun-setting ref="funSetting"></fun-setting>
  </div>
</template>
<script>
import funSetting from '@/components/sys/funsetting/index'

export default {
  name: "funsetting",
  components: { funSetting },
  data() {
    return {}
  },
  mounted() {
    this.$refs.funSetting.getData();
  },
  methods: {}
};
</script>